export default [
  {
    path: "/pengguna",
    component: () => import("@/pages/pengguna/List.vue"),
    meta: {
      requiredLevel: ["admin"],
    },
  },
  {
    path: "/pengguna/create",
    component: () => import("@/pages/pengguna/Create.vue"),
    meta: {
      requiredLevel: ["admin"],
    },
  },
  {
    path: "/pengguna/update/:id",
    component: () => import("@/pages/pengguna/Update.vue"),
    meta: {
      requiredLevel: ["admin"],
    },
  },
  {
    path: "/profil",
    component: () => import("@/pages/profile/Detail.vue"),
  },
  {
    path: "/login",
    component: () => import("@/pages/auth/login-page.vue"),
  },
  {
    path: "/forbidden",
    component: () => import("@/pages/Forbidden.vue"),
  },
  {
    path: "/:pathMatch(.*)*",
    redirect: "/404",
  },
  {
    path: "/404",
    component: () => import("@/pages/NotFound.vue"),
  },
];
